import { CreateScheduledTournamentScreen } from '@/screens/create-scheduled-tournament'

export default function () {
  return <CreateScheduledTournamentScreen />
}
